var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMapLocation = function SvgMapLocation(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.82037 15.7851L3.82044 15.7852C3.82881 15.7935 3.8373 15.8017 3.84592 15.8098L3.84598 15.8099L8.85465 20.5454C9.49715 21.1528 10.5022 21.1528 11.1447 20.5454L16.1534 15.8099L16.1534 15.8098C16.1621 15.8016 16.1706 15.7934 16.1789 15.7852L16.179 15.7851C19.6066 12.4029 19.6066 6.90992 16.179 3.5277C12.7637 0.157652 7.23561 0.157652 3.82037 3.52769C0.392777 6.90992 0.392777 12.4029 3.82037 15.7851ZM9.16634 9.75016C9.16634 9.28993 9.53944 8.91683 9.99967 8.91683C10.4599 8.91683 10.833 9.28993 10.833 9.75016C10.833 10.2104 10.4599 10.5835 9.99967 10.5835C9.53944 10.5835 9.16634 10.2104 9.16634 9.75016Z",
    fill: "#0258FF",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMapLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map-location.cfb04b07.svg";
export { ForwardRef as ReactComponent };